import { TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import './eletronic-service-personal-information.css';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

@Controller({ component: 'layout-personal-information', fragment: 'eletronic-service-personal-information' })
class EletronicServicePersonalInformationController extends BaseController{
  @OnMount({target: 'layout-personal-information'})
  onMountInput(): void {
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    this.context.set({
      encounterId,
      patientId,
    });
  }

  @OnMount({target: 'eletronic-service-personal-information-tab-control'})
  onTabControlMount(evt: MountEvent): void {
    //TODO V6: adjust on tabs
    const tabControl = evt.target as TabControlAPI;
    const currentTab = this.context.get('currentTab') as string;
    tabControl.setDefaultTab(currentTab);
  }

  @OnClick({target: ['all-tab', 'acm/sn-tab', 'ongoing-tab']})
  onTabClick(evt: ClickEvent): void {
    const tab = evt.target as TabWithContentAPI;
    this.context.set({currentTab: tab.getName()});
  }
}

export default EletronicServicePersonalInformationController;
